


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LabelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import QuotationList from './quotationList.vue';
import { createLabelUrl } from '@/components/label/labelOperation';
import { createCommentUrl } from '@/components/comment/commentOperation';
// import ShowLogModalBtn from '@/layout/components/logModal/showLogModalBtn.vue';
import DetailBox from '@/components/detailBox/detailBox.vue';

type ISolutionInfo = ISolution.IResponse.ISolutionInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component({
  components: {
    LabelOperation,
    CommentList,
    QuotationList,
    // ShowLogModalBtn,
    DetailBox,
  },
})
export default class SolutionDetail extends Vue {
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true}) private solution!: ISolutionInfo;
  get solutionId(): string {
    if (this.solution) {
      return this.solution.id;
    } else {
      return '';
    }
  }
  get labelUrl() {
    return createLabelUrl('Quotation', this.solutionId);
  }
  get commentUrl() {
    return createCommentUrl('Quotation', this.solutionId);
  }
  @Watch('solutionId')
  private watchSolutionId(solutionId: string) {
    if (solutionId) {
      this.requestSolutionDetail();
    }
  }
  private requestSolutionDetail() {
    this.$emit('refreshDetail', this.solution);
  }
  private editSolution() {
    this.$emit('edit', this.solution);
  }
  private removeQuotataion() {
    this.$emit('delete', this.solutionId);
  }
  private handleUpdateStatus(status: ISolution.ISolutionStatus) {
    this.$emit('statusChange', {
      solution: this.solution,
      status,
    });
  }
  // private createModule() {
    // ReqModuleModule.moduleList.createModule(this.payment!);
    // this.$router.push({
    //   name: 'CreateModule',
    // });
  // }
  private goRequirementPage(requirementId: string): void {
    this.$router.push({
      name: 'Requirement',
      params: {
        id: requirementId,
      },
    });
  }
  private handleLabelChange(newLabels: ILabelInfo[]) {
    this.$emit('labelChange', { solution: this.solution, labels: newLabels });
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      solution: this.solution,
      comment: newComment,
      type: 'ADD',
    });
  }
}
